/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Merge_By_SpeakersInputs */



/**
* | output |
* | --- |
* | "Merge by Speakers" |
*
* @param {Event_Group_Options_Merge_By_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_merge_by_speakers = /** @type {((inputs?: Event_Group_Options_Merge_By_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Merge_By_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner par locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführung nach Sprechern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci per relatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слияние по спикерам")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusión por oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按发言人合并")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーによるマージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं के आधार पर विलय करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fusão por Oradores")
	return /** @type {LocalizedString} */ ("Merge by Speakers")
});